import { $t } from '@/i18n';
import { defineComponent } from '@vue/composition-api';
import modalFactory from '@/utils/modalFactory';
import styles from './styles.module.scss';
const modal = defineComponent({
    name: 'DebugInfoModal',
    props: {
        options: {
            type: Object,
            required: true,
        },
    },
    methods: {
        handleOk() {
            this.$emit('message', {
                success: true,
            });
        },
        handleCancel() {
            this.$emit('message', {
                success: false,
            });
        },
    },
    render() {
        return <a-modal visible={true} onOk={this.handleOk} onCancel={this.handleCancel} ok-text={$t('k_ad53b5ff')} cancel-text={$t('k_4a7e579c')}>
      <div class={styles.container}>
        <p class={styles.title}>{$t('k_b9032647')}<span>{this.options.componentId}</span>{$t('k_f284640b')}</p>
        <p class={styles.tip}>{$t('k_689bb658')}</p>
        <p class={styles.warning}>{$t('k_c3a86ce7')}</p>
      </div>
    </a-modal>;
    },
});
const openComponentInfoModal = modalFactory(modal);
export default openComponentInfoModal;
